/**
 * Очищает все связанные с текущей сессией пользователя данные из localStorage.
 * Это предотвращает утечку или смешивание данных разных пользователей,
 * если один пользователь входит в систему сразу после другого без явного выхода.
 */
export const clearUserSession = (): void => {
  const sessionKeys = [
    'userId',
    'role',
    'username',
    'guid',
    'belongsStorage',
    'cityId',
    'pharmacyNum',
    'forceProfileCheck',
    'new_document_autosave',
    'onlineJournalActiveTab',
    'onlineJournalTab2ExpiryMonth',
    'periodReportData',
    'userCheckData'
  ];

  sessionKeys.forEach(key => {
    localStorage.removeItem(key);
  });
};
